// src/components/Layout.js
import React from 'react';
import NavMenu from './NavMenu';
import AccessibilityMenu from './AccessibilityMenu';
import Footer from './Footer';
import { Outlet } from 'react-router';
import VoiceCommandBar from './VoiceCommandBar';

const Layout = () => {
  return (
    <div className="layout">
      <VoiceCommandBar />
      <AccessibilityMenu />
      <NavMenu />
      <main className="main-content"><Outlet /></main>
      <Footer />
    </div>
  );
};

export default Layout;